export const EDICAO_2025 = {
  data: [
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_001.pdf",
        "name": "Review of disseminated concepts on galvanic corrosion",
        "authors": "Célia Aparecida Lino dos Santos, Claudete Silva Barbosa, Zehbour Panossian"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_002.pdf",
        "name": "Review of Corrosion and Abrasion in Iron-ore Slurry Steel Pipelines",
        "authors": "JULIANA LOPES CARDOSO, Zehbour Panossian, Fabián Andree Cerda Pastrian, Letícia Maria Sampaio Ribeiro"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_003.pdf",
        "name": "Performance of Inhibitors on Mitigating Preferential Weld Corrosion in Low Conductive Media",
        "authors": "Juliana Lopes Cardoso, Zepir Panossian, Marcos Luiz Henrique, Rodrigo da Silva Marques, Petrônio Zumpano Junior, Ilson Palmieri Baptista, Gustavo Vaz Leitão"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_004.pdf",
        "name": "Dependence of micro-morphology of Lime on pH adjustment of iron-ore slurry for corrosion control",
        "authors": "Fabián Andree Cerda Pastrián, Zehbour Panossian, Juliana Lopes Cardoso, Letícia M. S. Ribeiro"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_005.pdf",
        "name": "The internal corrosion in iron-ore slurry pipeline and the role of chloride ions in depassivation of the steel",
        "authors": "Fabián Andree Cerda Pastrián, Juliana L. Cardoso, Zehbour Panossian, Letícia M. S. Ribeiro"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_006.pdf",
        "name": "Overview of graphene-based smart coatings for corrosion protection ",
        "authors": "Danae Lopes  Francisco, Daiana Guerra Sacilotto, Juliana Lopes Cardoso,  Fabián Andree Cerda Pastrian, Zehbour Panossian"
    },
     {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_007.pdf",
        "name": "Magnelis® by Arcelormittal,: outstanding corrosion resistance proprieties of the first ZnAlMg coating produced in Brazil",
        "authors": "Sébatsien CREMEL"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_008.pdf",
        "name": "Influence of Carbon Steel Microstructure on CO‚ Corrosion Behavior",
        "authors": "Carlos Silva, Zehbour"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_009.pdf",
        "name": "Zinc-rich Paint Modified with Conductive Polymer Particles: Electrochemical Impedance Spec- troscopy for Understanding Phenomena in the Coating Layer",
        "authors": "Marília Santos Menossi Mortari, Paloma Vieira dos Santos, Juliana Pereira Flor, Zehbour Panossian"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_010.pdf",
        "name": "Electrochemical study of calcium carbonate scaling on steel in brine simulating pre-salt produced water",
        "authors": "Jean Vicente Ferrari, Juliana Francisco de Angelo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_011.pdf",
        "name": "Study of the corrosion resistance of 2024-T3 aluminum alloy anodized in TSA with the addition of graphene oxide",
        "authors": "Oscar Mauricio Prada Ramirez, Leandro Souza Domingues, Thassia Felix de Almeida, Renato Altobelli Antunes"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_012.pdf",
        "name": "Corrosion evaluation of 5052 aluminum alloy using superhydrophobic coatings based on vinyltri- ethoxysilane and stearic acid",
        "authors": "Daiana Sacilotto, Danae L Francisco, Zehbour Panossian"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_013.pdf",
        "name": "Smart coatings for corrosion protection and antifouling: an approach for marine offshore environ- ments",
        "authors": "Bruno Leonardo Ribeiro Oliveira, Jeferson Aparecido Moreto, Marcelo Rodrigues Pinto, Idalina Vieira Aoki"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_014.pdf",
        "name": "Aspectos práticos do uso de pigmentos inteligentes e do desempenho a longo prazo de revestimentos autorreparadores na pintura industrial",
        "authors": "Felipe Garcia Nunes, Elber Vidigal Bendinelli, Idalina Vieira Aoki"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_015.pdf",
        "name": "Green Stainless Steels as Solution for Corrosion and Wear Problems in the Agribusiness Sector",
        "authors": "Vitor Pagani De Souza, Wilian da Silva Labiapari, Vanessa de Freitas Cunha Lins"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_018.pdf",
        "name": "Corrosividade interna em dutos de derivados claros de petróleo e ação de inibidores de corrosão",
        "authors": "André Luiz Castro Bonfim, Vanessa Yumi Nagayassu Ferrari, Mariliza dos Santos, Lorena Cristina de O. Tiroel"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_019.pdf",
        "name": "Persistência de proteção de inibidores de corrosão em dutos de derivados claros de petróleo",
        "authors": "Caio Marques Neves, Johny Hernandes de Oliveira, Rosane Fernandes de Brito, Pedro Altoe Ferreira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_020.pdf",
        "name": "Falha por corrosão em tanques de armazenamento de ácido cítrico no segmento de Refino de petróleo",
        "authors": "André Luiz Castro Bonfim, Diego Gabriel Marques Mendonça, André da Silva Pelliccione"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_021.pdf",
        "name": "Corrosão sob tensão e desempenho de Sequestrantes de H2S em Fluidos de Perfuração Não-Aquosos",
        "authors": "André Luiz Castro Bonfim, Vitor Augusto de Rego Monteiro Pinheiro de Lima, Fabricio Pinheiro dos Santos, Walter Francisco Cardoso Junior"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_022.pdf",
        "name": "Degradação térmica de sequestrantes de H2S usados na produção de petróleo e impacto no segmento de Refino",
        "authors": "André Luiz Castro Bonfim, Rogério Mesquita de Carvalho, Bruno Charles do Couto, Thiago Andrade Delfino da Silva"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_023.pdf",
        "name": "Evaluation of the corrosion resistance of AA7075-T6 aluminum alloy anodized in a TSA  bath and sealed with polymer-based coatings",
        "authors": "Thassia Felix de Almeida, Oscar Mauricio Prada Ramirez, Hercilio Gomes de Melo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_024.pdf",
        "name": "Protectivity of Mineral Deposits on Metallic Materials in the Context of the Development of New Geothermal Energy Sources",
        "authors": "Arthur da Rocha Albertini, Sabrina Marcelin, François Ropital, Hercílio Gomes de Melo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_025.pdf",
        "name": "The versatility and high anticorrosion performance of carbon quantum dot obtained from pumpkin seed for carbon steel in 1 M HCl, 15% HCl and 170000 ppm Cl-1 CO2(sat) media.",
        "authors": "Victor Magno Paiva, Eliane D'Elia"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_026.pdf",
        "name": "USO DE AÇOS PATINÁVEIS EM ESTRUTURAS DE PAINÉIS SOLARES",
        "authors": "EGNALDA PEREIRA S PIMENTA, LEONARDO DE OLIVEIRA TURANI, MEIRE GUIMARÃES LAGE"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_027.pdf",
        "name": "Resistance of API 5L X70 MS and X70 MO Steels to Hydrogen Embrittlement in Sulfide Environments",
        "authors": "Élida Mariana Almeida Alves, Sandro Martins Ribeiro, Rosinei Batista Ribeiro, Eduardo Norberto Codaro"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_028.pdf",
        "name": "Reparo de Argamassa Cimentícia Leve com Epóxi Intumescente Proteção contrafogo",
        "authors": "Evandro Rivera Martin"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_029.pdf",
        "name": "Critérios de Aceitação PFP Danificado",
        "authors": "Evandro Rivera Martin"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_030.pdf",
        "name": "Proven Reduced Life Cycle Cost Technology For Splash Zone",
        "authors": "Evandro Rivera Martin"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_031.pdf",
        "name": "Cryogenic Spill Protection - CSP",
        "authors": "Evandro Rivera Martin"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_032.pdf",
        "name": "Novas Normas para Corrosão Sob Isolamento Térmico",
        "authors": "Evandro Rivera Martin"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_033.pdf",
        "name": "Sistema de 2 demãos para proteção CX da ISO 12944-9 e Norsok M501 2022",
        "authors": "Evandro Rivera Martin"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_034.pdf",
        "name": "Estudo do comportamento corrosivo do alumínio com relação a diferença entre substratos e qualidade da água de processo",
        "authors": "Rui Simas, Eliezer Ferraz de Almeida"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_036.pdf",
        "name": "Estudo do efeito da pandemia COVID19 na degradação por corrosão de ativos offshore",
        "authors": "Heberth Siriaco, Simone Louise D. C. Brasil, Ladimir Carvalho"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_037.pdf",
        "name": "The effect of low CO2 partial pressures on the development of corrosion products in a simulated confined space",
        "authors": "Jéssica Haylla Gontijo e Barcellos Teixeira, Mariana dos Reis Tagliari, Waleska Campos Guaglianoni"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_039.pdf",
        "name": "Avaliação da resistência à corrosão do aço galvannealed em meio a extrato de solo contendo casca da amêndoa do cacau como inibidor natural.",
        "authors": "Gilberto Bandeira dos Santos Filho, Vera Rosa Capelossi, Brunela Pereira da Silva, Tacia Costa Veloso"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_040.pdf",
        "name": "Biomass-derived corrosion inhibitors for oil production fields",
        "authors": "Jéssica Nogueira da Cunha, Marcello Martins Barroso, Brenno Danho Veras Evangelista, Michelle Jakeline Cunha Rezende, Eliane D'Elia"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_041.pdf",
        "name": "Avaliação da resistência à corrosão do aço pré-tratado com filme de silano em extrato aquoso do solo",
        "authors": "Lais Danielle dos Santos Teixeira, Vera Rosa Capelossi, Brunela Pereira da Silva, Tácia Costa Veloso"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_042.pdf",
        "name": "ESTUDO DE CASO - ANÁLISE DE INTERFERÊNCIA ELETROMAGNÁTICA EM GASODUTOS DE DISTRIBUIÇÃO POR LINHAS DE TRANSMISSÃO DE 545 kV E REDES DE 34,5 kV",
        "authors": "GLAUCIO ANTONIO WEIGERT"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_044.pdf",
        "name": "Comparison of graphene oxide functionalization methodologies with green corrosion inhibitors",
        "authors": "Nina Fonseca Soares, Gustavo Dias Soares, Raphael Gomes de Paula"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_045.pdf",
        "name": "Revestimentos nanocerâmicos em relação ao fosfato de ferro como pré-tratamento para pintura PU.",
        "authors": "Jane Zoppas Ferreira, Ágata Carine da Rosa Selau"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_047.pdf",
        "name": "Avanços em Tratamentos de Superfície para Aço Zincado: Pesquisa por Alternativas Sustentáveis",
        "authors": "Celia R Tomachuk, Sandra J Travassos, Gomes dos Santos, Hercílio G. de Melo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_048.pdf",
        "name": "Uma revisão da longevidade do desempenho anticorrosivo dos Produtos de Proteção Passiva contra Fogo (\"PFP\") em ambientes de Óleo & Gás",
        "authors": "Eider Santos"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_050.pdf",
        "name": "Estudo da Pátina em Esculturas de Aço Patinável no Campus da USP",
        "authors": "SJ Travassos, CR Tomachuk, HG. de Melo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_051.pdf",
        "name": "Avaliação do comportamento da corrosão do aço carbono SAE 1008 em meio de água do mar natural e a água do mar esterilizada.",
        "authors": "Vera Rosa Capelossi, Tácia Costa Veloso, Brunela Pereira da Silva, Lhaira Souza Barreto"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_054.pdf",
        "name": "Anticorrosive Behavior of Automotive Coolants Measured by Potentiodynamic Polarization Technique and Electrochemical Impedance Spectroscopy",
        "authors": "Marcello Rosa Dumont, Abda Florência da Silva Gomes, Thaís Filomena Moreira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_056.pdf",
        "name": "Plano de Pintura: Manutenção Preventiva de Tubulações com Uso de Jateamento Abrasivo Úmido",
        "authors": "Ákilas Girão Modesto, Ricardo Canuto Melo, Henrique Fonseca Leite Pina, Antenor Barra Dias Filho"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_057.pdf",
        "name": "Estudo comparativo da resistência à corrosão dos aços 304, 430, 410 e aços da série 200 em cozinhas industriais e domesticas.",
        "authors": "Marcel Soares Brito, Tiago da Silva Lima, Zehbour Panossian, Mariliza dos Santos"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_058.pdf",
        "name": "Diagnóstico de Corrosão por Salmoura (Brine Corrosion) em sistema de tubulações de unidade de destilação atmosférica de petróleo",
        "authors": "Eduardo Hiroshi Matsusaki, Jose Ademar Nucci Etter, Marcelo Munsignatti"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_059.pdf",
        "name": "Produção de revestimentos de NiCo com características hidrofóbicas e anticorrosivas",
        "authors": "Lucas Ferreira da Silva Dias, Bruno S. M, Loureiro, Dalva Cristina Baptista do Lago, André Rocha Pimenta"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_060.pdf",
        "name": "Híbridos de polianilina para inibição de corrosão",
        "authors": "Alessandra Duarte Dias, Loan Filipi Calheiros Souto, Bluma Guenther Soares"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_061.pdf",
        "name": "Corrosão de revestimento de monel em torre de oxidação de soda sulfídica",
        "authors": "Marina Ferraz Viana, Marcelo Pires Martins"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_063.pdf",
        "name": "Corrosion Protection Performance of Layered Double Hydroxides Intercalated with MoO„²{, WO„²{, and CrO„²{ Anions for Carbon Steel Surfaces in Saline Environment",
        "authors": "Vítor Vianna de Souza Machado, Fernando Wypych, Cláudia E. B. Marino, João Tedim"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_064.pdf",
        "name": "Estudo da suscetibilidade a fragilização por hidrogênio em aços inoxidáveis de diferentes microestru- turas",
        "authors": "Franceleno Silva Pereira, Mauro Andrés Cerra Florez, Walney Silva Araújo, Marcelo José Gomes da Silva"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_067.pdf",
        "name": "Influência da microestrutura na suscetibilidade à permeação de hidrogênio em diferentes metalurgias de Aços utilizados na indústria de óleo e gás.",
        "authors": "Filipe Oliveira Gomes dos Santos, José Antônio C. P. Gomes, Jefferson Rodrigues Oliveira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_068.pdf",
        "name": "Avaliação da Resistência à Corrosão de Revestimentos de Polianilina Eletrodepositados em Aço Carbono",
        "authors": "Rhuan Costa Souza, Marcella Matos Cordeiro Borges, Keyller Bastos Borges, Alysson Helton Santos Bueno"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_069.pdf",
        "name": "Avaliação da performance de inibidor de corrosão sobre superfícies pré-corroídas em ambientes com CO2",
        "authors": "Bárbara Lana de Resende, Rhuan Costa Souza, Carlos Eduardo Vieira Masalla"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_070.pdf",
        "name": "Impacto de condições estáticas e dinâmicas na corrosão localizada e uniforme do aço carbono API X65 em meios com CO2",
        "authors": "Carlos Eduardo Vieira Masalla, Rhuãn Costa Souza, Luan Carrera Santos"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_071.pdf",
        "name": "Efeito do tratamento térmico, da estratégia de varredura e da orientação na resistência à oxidação quasi-isotérmica em altas temperaturas da superliga Inconel 718 fabricada por manufatura aditiva",
        "authors": "Robson Bruno Dutra Pereira, Amaia Calleja Ochoa, Artur Mariano de Sousa Malafaia"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_072.pdf",
        "name": "Avaliação de ligas refratárias de alta entropia TaNbCrTiAl(Si) em altas temperaturas",
        "authors": "Artur Mariano de Sousa Malafaia, Bolivar dos Santos Dutra, Marcos Luiz de Souza Castro, Ana Bárbara Batista"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_073.pdf",
        "name": "Thermodynamic Prediction of Filler Surface Modification by APTES on Corrosion Resistance of Nano-TiO2/Waterborne Epoxy Coatings",
        "authors": "Isabel C.P. Margarit-Mattos, Oscar Rosa Mattos, Flavio V.V. de Sousa"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_074.pdf",
        "name": "Análise de Falhas em Oleodutos: Algoritmos de IA e Modelos de Corrosão Aplicados a Dados de Inspeção ILI",
        "authors": "Luan Carrera Santos, Carlos Eduardo Vieira Masalla, Rhuan Costa Souza"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_075.pdf",
        "name": "AVALIAÇÃO DA INFLUÊNCIA DE NANOPARTÍCULAS DE TITÂNIO NO PRÉ-TRATAMENTO À BASE DE ZIRCÔNIA APLICADO AO AÇO-CARBONO",
        "authors": "Lilian Vanessa Rossa Beltrami Beltrami, ESTHER ZILIOTTO VISENTIN"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_076.pdf",
        "name": "ANÁLISE DA ALTERNATIVA DE SUBSTITUIÇÃO DO FOSFATO TRICATIÔNICO POR FOSFA- TO DE NIÓBIO APLICADO SOBRE O AÇO CARBONO",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, RENATA MACHADO"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_077.pdf",
        "name": "COMPARAÇÃO ENTRE LEITOS DE ANODOS PROFUNDOS E SUPERFICIAIS DO SISTEMAS DE PROTEÇÃO CATÓDICA DO GASODUTO BOLÍVIA-BRASIL",
        "authors": "Jorge Fernando Pereira Coelho, Marco Antônio Gomes Estrella, Bruno dos Santos Claudino"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_078.pdf",
        "name": "Identificação de produtos de corrosão de bronzes quaternários formados na presença sulfatos",
        "authors": "Augusto Versteg, Gustavo Prestes de Vargas, Tiago Falcade"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_080.pdf",
        "name": "Impacto da incrustação do mexilhão-dourado na corrosão de equipamentos metálicos de usinas hidroelétricas",
        "authors": "Felipe Garcia Nunes, Elber Vidigal Bendinelli, Toseli de Farias Matos, Winter Sousa Freire"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_081.pdf",
        "name": "Caracterização do desempenho anticorrosivo de pastas condutoras utilizados em Complexos Eólicos",
        "authors": "Felipe Garcia Nunes, Victor Freitas de Jesus, Elber Vidigal Bendinelli"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_084.pdf",
        "name": "Robô de Pintura - Primeiro trabalho de campo & Resultados (Financeiro & SMS)",
        "authors": "Carlos André Santos, André Koebsch, Ezequiel Figueira Jorge"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_092.pdf",
        "name": "NdFeB Corrosion Behavior in Non-magnetized and Magnetized States",
        "authors": "Célia Aparecida Lino dos Santos, Fabián Andrée Cerda Pastrian, Daniel Sierra Yoshikawa, Fernando José Gomes Landgraf"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_095.pdf",
        "name": "Monitoramento da biocorrosão em sistema de transporte de minério para controle de impactos ambientais",
        "authors": "Diogo Azevedo Coutinho, Walter Cravo Jr, Ana Calil, Luiz Andre Pinto"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_096.pdf",
        "name": "Desempenho de dutos em ligas resistentes à corrosão durante operações de pré-comissionamento e hibernação",
        "authors": "Vinicius Flores, Luiz Andre Pinto, Flavia Guedes, Maira Paula Sousa"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_097.pdf",
        "name": "Análise do perfil bacteriano em liga CRA de duto hibernado com aplicação de produto biocida",
        "authors": "Maira Paula Sousa, Luiz Andre Pinto, Viviane Oliveira, Anayara Nazar Pinho"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_098.pdf",
        "name": "Propriedades anticorrosivas e de autorreparo de revestimentos inteligentes contendo microcápsulas com núcleo ativo de epóxi e imidazol",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, Daniela Maria Cecatto, Ademir José Zattera"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_099.pdf",
        "name": "Efeito do processamento e da adição de elementos terras raras na resistência à corrosão da liga Mg-Dy/Gd-Zn-Zr",
        "authors": "Célia Regina Tomachuk dos Santos Catuogno, Paula Leticia Correa de Toledo Cury, Carlos Angelo Nunes"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_100.pdf",
        "name": "Effect of Surface Finish on the CO‚ Corrosion of a High-Strength Carbon Steel",
        "authors": "Pedro Netto da Silva"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_101.pdf",
        "name": "Liners Termoplásticos: Solução eficaz em reabilitação de dutos com corrosão interna",
        "authors": "Alexandre Villaça Simões, Rodrigo Dias Assis Saldanha, Saulo Matias"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_104.pdf",
        "name": "Análise da Resistência à Corrosão de Ferro Fundido Revestido com Cromo Duro em Diferentes Eletrólitos para Aplicações na Indústria de Alimentos",
        "authors": "Lílian Vanessa Rossa Beltrami, Camila Fravetto, Marielen Longhi"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_106.pdf",
        "name": "Uso de IA na predição de corrosão - a construção de uma metodologia assertiva",
        "authors": "Franci D P Gaensly, Carlos E. Silva, Merlin C. E. Bandeira, Adriana C. Rocha"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_108.pdf",
        "name": "Study Case: Evaluating Alloy 35 as a Viable Alternative for Use in Crude Unit Overhead Condensers",
        "authors": "Renata Mota, Guilherme Basso, Karla Guimarães"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_110.pdf",
        "name": "Aplicação de membrana elastomérica resselável a base a reservação de ativos que sofrem com Corrosão por Fresta e Aeração Diferenciada",
        "authors": "João Vitor Sales, Pedro Hita"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_111.pdf",
        "name": "Alternativa verde para a produção de resina alquídica",
        "authors": "FELIPE SANTIAGO SOARES, Flavio Vieira Vasques de Sousa, Elber Vidigal Bendinelli, Felipe Garcia Nunes"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_112.pdf",
        "name": "Resistência à corrosão do aço inoxidável super duplex UNS S32760 soldado por fricção em ambientes ácidos e salinos.",
        "authors": "GUILHERME DOS SANTOS VACCHI, Anibal Andrade Mendes Filho, Luciano Andrei Bergmann, Cristian Pohl Meinhardt"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_113.pdf",
        "name": "Comportamento eletroquímico do aço com revestimento poliuretano base água",
        "authors": "Juan David Zapata Marulanda, Silvia  Margonei Amesquita Tamborim, Jeaneth Teresa Corredor Gonzalez"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_114.pdf",
        "name": "Corrosion resistance of a super-duplex stainless steel for carbon capture and storage",
        "authors": "Murilo Simoes, Wenle He, Daniel Coelho, Alan Souza"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_115.pdf",
        "name": "Evaluation of Different Manufacturing Processes of Hydraulic Lines",
        "authors": "Murilo Simoes, Wenle He, Daniel Coelho, Alan Souza"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_116.pdf",
        "name": "GERENCIAMENTO DA CORROSÃO EXTERNA: MONITORAMENTO E MANUTENÇÃO DE REVESTIMENTO EXTERNO DE GASODUTOS",
        "authors": "Mateus Costa Medeiros, Helio Alves Ferreira, Wendel Soares Correia"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_117.pdf",
        "name": "Impact of water Content and CO2 ¬ Partial Pressure in natural Gas transport and Carbon Capture and Storage (CCS) Systems",
        "authors": "Tatiana das Chagas Almeida, Merlin Cristina Elaine Bandeira, Rogaciano Maia Moreira, Yure Menezes"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_118.pdf",
        "name": "Implementation of a telecom tower integrity management program.",
        "authors": "Luciana Torres, Marcelo de Oliveira Siqueira, João Paulo de Oliveira Pedrosa"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_119.pdf",
        "name": "Proteção contra a corrosão em ensaios hidrostáticos para a indústria do petróleo e gás",
        "authors": "Ronnie Singh, FELIPE GAGLIARDO SCHEIDL, Daniel Amorim, Bárbara Oliveira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_120.pdf",
        "name": "Proteção contra Corrosão dos Fundos dos Tanques de Armazenamento  em Contato com o Solo - Um caso brasileiro.",
        "authors": "Bárbara Oliveira, Ronnie Singh, FELIPE GAGLIARDO SCHEIDL, Daniel Amorim"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_121.pdf",
        "name": "Use of Volatile Corrosion Inhibitors (VCIs) in the Mining Industry",
        "authors": "FELIPE GAGLIARDO SCHEIDL, Ronnie Singh, Vinícius Vasconcelos"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_122.pdf",
        "name": "Corrosão em sistema de fundo de torre regeneradora de amina de UTGR: Estudo de caso de uma refinaria da Petrobras",
        "authors": "Paulo Roberto Menoncin Filho, Carolina de Paula Pereira, Claudiomar Santos Oliveira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_123.pdf",
        "name": "Oxidation behavior of novel Fe-Ni-Cr-Co-Cu-Mo multicomponent steels with and without Si addition",
        "authors": "Emma White, João Batista Ribeiro Martins, Marcelo Falcao de Oliveira, Mathias Galetz"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_124.pdf",
        "name": "Resistência à Oxidação e Sulfetação da Liga Multi-Elementos Principais TiNbCr",
        "authors": "Isabela Dainezi, Brian Gleeson, Rodrigo da Silva"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_125.pdf",
        "name": "Estudo da estabilidade do eletrodo de referência Ag/AgCl/sw",
        "authors": "Simone Louise Delarue C. Brasil, Kleiton da Cruz Cunha, Fabiano Barbieri Gonzaga"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_126.pdf",
        "name": "Estudo de utilização de óxido de grafeno reduzido como aditivo para resina epóxi anticorrosiva aplicada através de spray coating.",
        "authors": "Denise Souza de Freitas, Gabriel Batalha Leoni, Victor Gabriel Sermoud Rosa"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_127.pdf",
        "name": "Simulação Termodinâmica de Incrustações Inorgânicas em cenários subsea na Indústria de Óleo e Gás",
        "authors": "Tiago C. Freitas, Jussara de M. Silva, Simone L. D. C. Brasil"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_128.pdf",
        "name": "Estudo de corrosão localizada em dutos de aço inox em (BE)CCS: comparação entre dados de software termodinâmicos e ensaios de laboratório",
        "authors": "Brenda C. S. Cardozo, Merlin C. E. Bandeira, Tatiana C. Almeida"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_129.pdf",
        "name": "Mecanismos de corrosão intergranular e autocura no aço inoxidável lean duplex 2404 envelhecido a altas temperaturas",
        "authors": "Cristie Luis Kugelmeier, Guilherme dos Santos Vacchi, Rodrigo Magnabosco, Carlos Alberto Della Rovere"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_130.pdf",
        "name": "Limpeza de Superfícies Metálicas com Laser de Alta Potência: Uma Alternativa Sustentável para a Indústria de Óleo e Gás",
        "authors": "MIRIAM ZARETH PARRA SEJAS, SANTIAGO JAVIER CARAGUAY CORREA, THIAGO SOARES PEREIRA"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_131.pdf",
        "name": "Texturização de superfícies com laser de alta potência para aplicação de revestimentos orgânicos para a indústria de óleo e gás.",
        "authors": "ANDRE KOEBSCH, THIAGO SOARES PEREIRA, FRANCISCO RATUSZNEI"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_132.pdf",
        "name": "Estudo dos efeitos dos parâmetros na eletrodeposição de revestimentos a base de óxido de grafeno em uma liga superplástica de NiTi no comportamento à corrosão",
        "authors": "Victor Cardoso Campideli, Marcos Daniel Vozer Felisberto, Leandro de Arruda Santos, Dalila Chaves Sicupira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_133.pdf",
        "name": "Avaliação de permeabilidade de pastas cimentícias ao CO2 e íons cloretos e impacto na corrosão de colunas de poços injetores de CO2",
        "authors": "Melissa Correa Lourenço, Merlin C. E. Bandeira, Oscar R. Mattos, Felipe R Assunção"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_134.pdf",
        "name": "Gleeble® thermomechanical simulation of the heat-affected zones of lean duplex stainless steel 2404: Understanding the effect of cooling rates on microstructural evolution and corrosion resistance",
        "authors": "Cristie Luis Kugelmeier, Rodrigo da Silva, Guilherme dos Santos Vacchi, Carlos Alberto Della Rovere"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_136.pdf",
        "name": "Reuse and life extension of flexible flowlines based on field experience and laboratory research",
        "authors": "Merlin C E bandeira, Fabricio P. Santos, Oscar R Mattos"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_137.pdf",
        "name": "Influence of Electrolyte Drop Volume and Thickness on Oxygen Reduction Reaction and Atmospheric Corrosion of Stainless Steel",
        "authors": "Lázaro Aleixo dos Santos, Carolina Vicente Moraes, Anderson de Oliveira Fraga, Luís Frederico P. Dick"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_138.pdf",
        "name": "Corrosividade atmosférica em torres de transmissão: limitações da especificação técnica tradicional e os desafios das mudanças climáticas",
        "authors": "Camila Marçal Gobi Pacher, Julia Stefany Chagas Albrecht, Mariana D'Orey Gaivão Portella Bragança, Camila Melo Pesqueira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_139.pdf",
        "name": "REVESTIMENTO ORGÂNICO CONTENDO INIBIDOR NATURAL A BASE DE LIMONENO PARA A PROTEÇÃO CONTRA A CORROSÃO DO AÇO AISI 1020",
        "authors": "Mariana Straube da Graça Pereira, Débora de Abrantes Nunes Leal, Bruno Campos da Silva, Cláudia Eliana Bruno Marino"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_140.pdf",
        "name": "Proteção à corrosão de superfícies de zinco por banhos contendo compostos de Cr(III) modificados por pós-tratamento com reagentes oxidantes in situ",
        "authors": "Antônio Buaczik Júnior, Luís Frederico Pinheiro Dick, Gerhard Hans Knörnschild, Celia Regina Tomachuk dos Santos Catuogno"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_142.pdf",
        "name": "Análise da influência de meios contendo H2S e CO2 na degradação de pastas cimentícias para colunas de poços armazenamento de CO2.",
        "authors": "Olga M. O. Araújo, Cintia G. Ferreira, Oscar R Mattos, Merlin C E Bandeira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_145.pdf",
        "name": "Armazenamento Subterrâneo de Hidrogênio no Pré-Sal: Desafios Microbianos e Impactos na Integri- dade Estrutural",
        "authors": "Luciano Procópio da Silva, Márcia Lutterbach"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_146.pdf",
        "name": "Sistema de preparação de superfícies a laser para pequenas áreas e de difícil acesso: Remoção de corrosão e revestimentos anticorrosivos.",
        "authors": "FRANCISCO RATUSZNEI, MIRIAM ZARETH PARRA SEJAS, SANTIAGO JAVIER CARAGUAY CORREA"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_147.pdf",
        "name": "Ocorrência de Ataque por Hidrogênio em Alta temperatura, HTHA, em um reator de unidade de hidrotratamento de diesel: inspeção e avaliação de resultados.",
        "authors": "Gustavo Spera Alves, Gustavo Henrique Dian"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_148.pdf",
        "name": "OCorrência de corrosão sob tensão por cloreto em unidade de reforma catalítica: Análise de falhas e avaliação de integridade.",
        "authors": "Gustavo Spera Alves, Aldo gil de souza miguel"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_149.pdf",
        "name": "Corrosão em Pontes e Estruturas: Como o Zinco Pode Proteger o Futuro",
        "authors": "Camile Paula Theodoro, Daniel Ferraz"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_150.pdf",
        "name": "Determinação Teórica e Experimental da Solubilidade de CO2 para o Estudo da Precipitação de Siderita em Poços de Injeção de Água",
        "authors": "Celso L.M. Alves, Aline M.A. Novaes, Oscar R. Mattos, Tatiana Almeida"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_151.pdf",
        "name": "Estudo da Formação e Impacto da Camada de Carbonato de Ferro na Corrosão do Aço Carbono em Ambiente Confinado",
        "authors": "Nathalia T. Lima, Marcelo T.G. Sampaio, Rogaciano M. Moreira, Ilson P. Baptista"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_154.pdf",
        "name": "FORMAÇÃO DE ÂNODOS INCIPIENTES NOS REPAROS LOCALIZADOS - EFEITO DO TEOR DE SÍLICA DE CASCA DE ARROZ",
        "authors": "Marcelo Henrique Farias de Medeiros, Igor Rossi Remenche, Paulo Augusto Daschevi, Marcelo Miranda Farias"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_155.pdf",
        "name": "INFLUÊNCIA DA PRESSÃO PARCIAL DE NITROGÊNIO DURANTE PROCESSO PVD NA APLI- CAÇÃO DE REVESTIMENTO SOBRE O AÇO RÁPIDO M2",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, Fernando Spanholi Teles, Marielen Longhi"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_159.pdf",
        "name": "INFLUÊNCIA DA MORFOLOGIA DE CARGA DE VIDRO NO DESEMPENHO DE TINTA EPOXI SOB CICLOS DE PRESSÃO",
        "authors": "Nykolle Fabiane Camilo Fernandes, Hongpeng Zheng, Elber Vidigal Bendinelli"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_160.pdf",
        "name": "Sistemas de Preservação Através de Tecnologia VCI em Armazéns para Companhias Offshore - Arm Rio Case",
        "authors": "Daniel Amorim, Ronnie Singh, FELIPE GAGLIARDO SCHEIDL"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_162.pdf",
        "name": "Estudo de incorporação e liberação de inibidores de corrosão a partir de hidróxidos duplos lamelares",
        "authors": "Nykolle Fabiane Camilo Fernandes, Ian Miraglia Acuña, Letícia Vitorazi"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_163.pdf",
        "name": "Mecanismo de corrosão pelo CO2: Um novo entendimento",
        "authors": "Jéssica N. Cunha, Marcelo T.G. Sampaio, Eliane D'Elia, Oscar R. Mattos"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_164.pdf",
        "name": "Gerenciamento e monitoramento do consumo de inibidor de corrosão na Transpetro",
        "authors": "JULIANA DO VAL BURGOS"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_165.pdf",
        "name": "DESEMPENHO ELETROQUÍMICO EM SALIVA SIMULADA DE BLOCOS CAD/CAM DE LIGA Co-Cr-Mo PARA FABRICAÇÃO DE PRÓTESES DENTÁRIAS",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, Natacha Simoni Bagnara, María Cristina Moré Farias"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_166.pdf",
        "name": "Evaluation of Si Microcapsules with Ce as Anticorrosive Additive in Paints for Metal Coatings",
        "authors": "Daniel Rodrigues Oliveira, Adria Rodrigues Teixeira, João Pedro Rodrigues de Souza, Camila de Lima Ribeiro"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_167.pdf",
        "name": "REMOÇÃO E RECUPERAÇÃO DE NÍQUEL DE EFLUENTES DE PROCESSOS GALVÂNICOS UTILIZANDO DE ELETRODIÁLISE E ELETRORRECUPERAÇÃO",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, Eduardo Antônio Zanella, Camila Baldasso"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_168.pdf",
        "name": "ESTUDO DA RELAÇÃO ENTRE DIFERENTES PRÉ-REVESTIMENTOS APLICADOS SOBRE O AÇO ZINCADO COM E-COAT EPÓXI",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, MARINA GIRARDI AGNOLETTO"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_169.pdf",
        "name": "Obtenção de revestimento base epóxi e nanoplaquetas de grafeno decoradas com nióbio para proteção anticorrosiva e antirradar.",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, Marielen Longhi, Daniela Maria Cecatto, Bluma Guenther Soares, Ademir José Zattera"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_170.pdf",
        "name": "Desempenho anticorrosivo de revestimento híbrido á base de silano combinado à nanofibras de celulose e imidazol aplicados sobre o aço carbono e recobertos com resina epoxi.",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, Marielen Longhi, Camila Danielli"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_171.pdf",
        "name": "Avaliação do comportamento quanto à corrosão das ligas 3003 e 6063 em fluído de arrefecimento por meio de ensaios eletroquímicos",
        "authors": "Celia Aparecida Lino dos Santos, Sidney Oswaldo Pagotto Júnior, Denis Rodrigues da Silva, Matheus Machado de Souza"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_172.pdf",
        "name": "CONTROLE DA CORROSÃO INTERNA EM GASODUTOS DE TRANSPORTE DE GÁS NATUR- AL E BIOMETANO",
        "authors": "Jorge Fernando Pereira Coelho, Marco Antônio Gomes Estrella"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_173.pdf",
        "name": "ESTUDO DA CORROSIVIDADE DE ALGUNS SOLOS, NA REGIÃO DE PALMAS, EM CONTATO COM AÇOS UILIZADOS EM POLIDUTOS",
        "authors": "Alexon Braga Dantas, Lorrane Sousa Goncalve, João Carlos Sarri Junior"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_175.pdf",
        "name": "DEVELOPMENT OF AN ANTI-CORROSIVE ADHESIVE FROM RECYCLED POST-CON- SUMER PET FOR APPLICATION ON LOW-CARBON STEEL",
        "authors": "Beatriz M. A. Dias, Hugo Guimaraes Palhares, Teresa C. A. V. Rosario, Fernando R. da Cunha"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_176.pdf",
        "name": "Anticorrosion Properties of Hierarchical Hydrophobic Surfaces Fabricated on Different Aluminum Alloys",
        "authors": "Rafaela Rocha Cunha, Eduarda Machado Jose, Guilherme Kusler Possani, Eduardo Luis Schneider"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_179.pdf",
        "name": "A Cathodic Protection Criteria and the Integrity of Subsea System in Brazil",
        "authors": "Jefferson Oliveira, MARCELO SCHULTZ"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_180.pdf",
        "name": "Electrochemical behavior of AA2024-T3 aluminum alloy anodized in mixed sulfuric and carboxilic acid electrolytes",
        "authors": "Guilherme K. Possani, Eduardo L. Schneider, Lisete C. Scienza"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_181.pdf",
        "name": "Reengenharia de Suportes para proteção da corrosão",
        "authors": "Carlos Alexandre Martins da Silva, Monica da Cunha Marroig, RONALD CORSANI KAMIMURA, WALBER CAPACI DE ARAUJO"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_182.pdf",
        "name": "Biocidas inorgânicos associados aos taninos e óleo de Neem no controle a corrosão induzida por microrganismos",
        "authors": "Sara Horácio de Oliveira Maciel, Danilo S. Oliveira, Ellen L. Silva, Magda R. S Vieira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_184.pdf",
        "name": "Descarbonização (CCS): Lacunas e desafios para o gerenciamento da corrosão interna no transporte de CO2 impuro",
        "authors": "Pedro Altoe Ferreira, Aline Lins da Silva Gomes"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_185.pdf",
        "name": "Trem fantasma pode interferir em dutos enterrados?",
        "authors": "João Paulo Klausing Gervásio"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_186.pdf",
        "name": "Reabilitação de Duto de Água Oleosa com Revestimento Interno",
        "authors": "Alexsandro da Silva Cerqueira, Milene Lagoas de Almeida Desmarais, Carlos Alexandre Martins da Silva"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_187.pdf",
        "name": "Elastomeric coatings as an anticorrosive strategy on offshore platforms - cases after 5 years",
        "authors": "Jeferson Leite de Oliveira, Eduardo Siqueira de Araujo Conde"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_188.pdf",
        "name": "Caracterização eletroquímica de diferentes águas de lavagem de alumínio de um sistema industrial",
        "authors": "Tiago Falcade, Tobias Bertoldi Agostini"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_190.pdf",
        "name": "On the use of digital twins to improve subsea pipelines integrity management",
        "authors": "Thiago Wilvert, Miguel Burg Demay, Suelen Seledes Rodrigues, Tiago Antonio de Queiroz Yunes, Gustavo Donatelli"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_191.pdf",
        "name": "INFLUENCE OF COPPER ON THE CORROSION RESISTANCE OF DUPLEX STAINLESS STEEL 2205 IN A SALINE SOLUTION WITH DIFFERENT ELECTROLYTE TEMPERATURES",
        "authors": "Yara Amorim de Figueiredo, Ana Kaylane Farias Hoffman, Ana Larissa Soares Cruz, Daniel Bernardes Silva"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_195.pdf",
        "name": "EVALUATION OF THE CRITICAL PITTING TEMPERATURE (CPT) AND CHRONOAMPER- OMETRY OF DUPLEX STAINLESS STEEL 2205 WITH DIFFERENT COPPER ADDITIONS",
        "authors": "Ana Kaylane Farias Hoffman, Yara Amorim de Figueiredo, Ana Larissa Soares Cruz, Daniel Bernardes Silva"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_196.pdf",
        "name": "Efeito protetivo de um revestimento nanocompósitos a base de resina epóxi e nanopartículas de celulose tratadas com imidazol",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, Camila Danielli, Daniela Maria Cecatto, Ademir José Zattera"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_198.pdf",
        "name": "Hexafluorozirconic Acid-based Nanoceramic Conversion Coatings on AA3105 Aluminum Alloy: In-fluence of the Presence of Copper in the Deposition Bath",
        "authors": "Lisete Cristine Scienza, Gabriel Adriane Garcia, Giovana Santos Barbosa, Guilherme Kusler Possani"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_199.pdf",
        "name": "Desenvolvimento de Eletrodos de Referência de Ag/AgCl para Aplicações em Altas Temperaturas",
        "authors": "Wagner Reis da Costa Campos, Gustavo Aluízio Dorico Pinto, Patrícia Canazart Azzi"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_200.pdf",
        "name": "Influence of overprotection on AC corrosion. Analysis of a real case.",
        "authors": "Ivano Magnifico"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_202.pdf",
        "name": "Influência do pH do sol-gel contendo nanofibras de celulose e APTES na resistência à corrosão de revestimentos híbridos",
        "authors": "LILIAN VANESSA ROSSA BELTRAMI, Larissa Rodrigues Martins, Marielen Longhi, Daniela Maria Cecattto"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_203.pdf",
        "name": "Influência do grau de sensitização na resistência à corrosão de aço inoxidável austenítico com baixo níquel",
        "authors": "Adryel Vitor Barbosa da Silva, Bruno Gomes Linhares, Walney Silva Araújo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_209.pdf",
        "name": "Estudo comparativo da resistência à corrosão dos aços inoxidáveis AISI 304L e UNS S32304 em diferentes meios contendo cloreto e em diferentes temperaturas",
        "authors": "Caroline Nazaré Gonçalves, Patrícia Canazart Azzi, Douglas Mendes Ribeiro"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_211.pdf",
        "name": "Estudo da resistência à corrosão do Aço DP600 e da liga AA5052 soldados por FSW",
        "authors": "Giovanni Brandi Cirillo Iazigi, Nathanael Morais, Bruno Nogueira Pereira, João Victor de Sousa Araujo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_212.pdf",
        "name": "Passive Film and Pitting Corrosion Behaviour of Super Martensitic Stainless Steels in Seawater: Influence of Niobium and Titanium",
        "authors": "César Augusto Duarte Rodrígues, Germano . Tremiliosi-Filho"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_213.pdf",
        "name": "Avaliação do aço AISI 348 para utilizações nucleares após envelhecimento a 500°C",
        "authors": "Gustavo Kolbe Cazelli, Giovanni Brandi Cirillo Iazigi, Bruno Nogueira Pereira, Isolda Costa"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_214.pdf",
        "name": "Melhoria contínua em inspeção e manutenção de sistemas de proteção catódica.",
        "authors": "Marcus Fischer Nunes, Valéria Martins"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_215.pdf",
        "name": "Analise comparativa à corrosão de ligas de níquel deformadas a frio",
        "authors": "Regina Paula Garcia Moura, Gabrielli Marina Chicrala Gonçalves, Taina Luana da Silva"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_217.pdf",
        "name": "The effect of aging temperature on the corrosion resistance of the AISI 348",
        "authors": "Nathanael Wagner Sales Morais, Gustavo Kolbe Cazelli, Bruno Nogueira Pereira, Edson Garcia Gomes"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_218.pdf",
        "name": "Investigation of pitting corrosion resistance of austenitic stainless steels according to ASTM G48-A",
        "authors": "Ana Aline Coelho Alcanfor, Bruno Gomes Linhares, Walney Silva Araújo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_221.pdf",
        "name": "Inibição de Corrosão do Aço AISI 1018 por Carbon Dots Dopados com Nitrogênio e Enxofre em Meio Ácido.",
        "authors": "LUIS GUSTAVO RODRIGUES SA, Beatriz Forte Quintela, Carlos Henrique Barbosa Queiroz, Tiago Melo Freire"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_222.pdf",
        "name": "Avaliação da Eficiência de Inibição dos Carbon Dots em Solução Salina Aerada e Saturada com CO2",
        "authors": "Walney Silva Araujo, Roberta Bastos Vasques, Beatriz Forte Quintela, Alvaro Augusto Oliveira Magal- hães"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_223.pdf",
        "name": "Estudo da variabilidade de resultados em ensaios de névoa salina neutra",
        "authors": "Natasha Polanowski Hammel, Zehbour Panossian, Arthur Tigre Oliveira, Marcio Bispo de Almeida"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_224.pdf",
        "name": "Electrochemical characterization of carbon steels in synthetic seawater in the absence and presence of CO2",
        "authors": "Roberta Bastos Vasques, Otílio Braulio Freire Diógenes, Ana Aline Coelho Alcanfor, Daniel de Castro Girão"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_225.pdf",
        "name": "Study of the corrosion resistance of low carbon steels in a synthetic seawater solution in the presence of CO2",
        "authors": "Ana Aline Coelho Alcanfor, Daniel de Castro Girão, Hamilton Ferreira Gomes de Abreu, Walney Silva Araújo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_227.pdf",
        "name": "O uso de sistemas de automação em ensaios de eletroquímica e corrosão",
        "authors": "Israel Lima Monte Gonçalves, Denise Souza de Freitas, Jose Victor de Oliveira Goudar, Rafael de Abreu Vinhosa"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_228.pdf",
        "name": "Monitoramento da corrosão branca e da perda de revestimento de zinco em estruturas galvanizadas por imersão a quente expostas à atmosfera marinha por 18 anos.",
        "authors": "William Barbosa Borges, Lizandra Gregório dos Santos"
    },
     {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_229.pdf",
        "name": "Diversos revestimentos de zinco na proteção contra a corrosão do aço",
        "authors": "Ricardo Suplicy Goes"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_231.pdf",
        "name": "Influence of concentration and pH of a Zr-based conversion coating on a galvanized steel",
        "authors": "Jane Zoppas Ferreira, Carolina Remedi de Menezes"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_233.pdf",
        "name": "Influence of Microstructure on the Formation of Corrosion Products in Steels Susceptible to SCC-CO",
        "authors": "Guilherme Henrique Alves Andrade, Carlos Alberto da Silva, Zehbour Panossian"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_234.pdf",
        "name": "Avaliação Do Desempenho De Inibidores De Corrosão Do Tipo Amina Em Aço API X65 Em Meio Rico Em CO2: Um Estudo De Propriedades Eletroquímicas E Tribológicas.",
        "authors": "Rafaela Batista Marques, Giovanni dos Santos Batista, Eleani Maria da Costa, Carlos Alexandre dos Santos"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_235.pdf",
        "name": "High Temperature Oxidation Behavior of multi-principal element alloy CrCoNiAlTi in atmospheric conditions",
        "authors": "Julio da Silva Wysard"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_236.pdf",
        "name": "Gerenciamento e monitoramento do consumo de inibidor de corrosão na Transpetro",
        "authors": "JULIANA DO VAL BURGOS"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_237.pdf",
        "name": "Validação em campo de metodologias de desgaste controlado da camada de zinco para aços galvaniza- dos",
        "authors": "Felipe Garcia Nunes, VICTOR FREITAS DE JESUS, ELBER VIDIGAL BENDINELLI, DÉBORA FRANÇA DE ANDRADE"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_238.pdf",
        "name": "ANÁLISE DE FALHA POR CORROSÃO DE VENT FABRICADO EM AÇO INOXIDÁVEL SU- PERDUPLEX EM UMA UNIDADE OFFSHORE",
        "authors": "André da Silva Pelliccione, Clóvis Ribeiro Rodrigues, Paulo Rogério Tavares da Silva, Leandro G. de Oliveira"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_239.pdf",
        "name": "Corrosão em Trocadores de Calor de Placas de Alumínio Brasadas em Planta de Processamento de Gás Natural.",
        "authors": "ALESSANDRO SANTANA CRUZ, André da Silva Pelliccione, Luiz Tiago Balbi Finkel"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_240.pdf",
        "name": "Performance evaluation of orange essential oil as a corrosion inhibitor",
        "authors": "Melissa Moraes dos Anjos, Victoria Rosa Euzebio de Azevedo, Washington Pereira de Carvalho"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_241.pdf",
        "name": "ESTUDO DA RESISTÊNCIA À CORROSÃO DE REVESTIMENTOS COMPÓSITOS UTILIZAN- DO O PÓ DE PET PÓS CONSUMO",
        "authors": "JORGE FERREIRA DA SILVA FILHO, EMILLY GABRIELLE DA SILVA, MARIA DE FATIMA FIRE- MAN DE OLIVEIRA"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_243.pdf",
        "name": "Influence of iron content in IN625 nickel-based coatings - A review focused on applications in chlo- ride/H‚ S/CO‚ environments",
        "authors": "Lucas Moreira Ferreira, Carlos Angelo Nunes, Maria Ismênia Sodero Toledo Faria"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_244.pdf",
        "name": "Electrochemical behavior of alternative nickel alloys in 3.5 wt% NaCl solution",
        "authors": "Pedro Turetta de Senna, Camila Dias dos Reis Barros, Eduardo Alencar de Souza"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_248.pdf",
        "name": "Investigation of Stress Corrosion Cracking Initiation in Compressive Regions of Bent Specimens Using Finite Element Analysis",
        "authors": "Rodrigo R. A. Garcia, Julia K. M. Magalhaes, Oscar R. Mattos"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_249.pdf",
        "name": "A Resistência à Corrosão de Ligas de Alta Entropia",
        "authors": "Anderson Fraga, Luís Frederico Pinheiro Dick"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_250.pdf",
        "name": "Avaliação da Corrosividade Atmosférica e seus Impactos em Materiais Metálicos no Complexo do Pecém",
        "authors": "Roberta Bastos Vasques, Raimundo Otaciano Mello Filho, Sebastien Cremel, Walney Silva Araujo"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_251.pdf",
        "name": "Avaliação do Desempenho Anticorrosivo de Revestimentos à Base de Zinco por Meio de Ensaios de Corrosão Atmosférica",
        "authors": "Daniel de Castro Girão, Otílio Braulio Freire Diógenes, Roberta Bastos Vasques, Raimundo Otaciano Mello Filho"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_252.pdf",
        "name": "Simulação física de zonas termicamente afetadas do aço inoxidável lean duplex 2101: Microestrutura, comportamento de corrosão e análise por DICTRA® em diferentes taxas de resfriamento",
        "authors": "Cristie Luis Kugelmeier, Rodrigo da Silva, Guilherme dos Santos Vacchi, Rodrigo Magnabosco"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_253.pdf",
        "name": "O uso de técnicas espectroscópicas e de caracterização de superfície para análise dos produtos de corrosão",
        "authors": "Lorena Almeida Cadete da Costa, Daniela Procópio Aguiar, Pamela Vicente Martins"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_254.pdf",
        "name": "Desenvolvimento de melhor rota de tratamentos térmicos e termoquímicos de forma customizada para uso de aços em ambientes corrosivos e abrasivos.",
        "authors": "Mariana Botelho Barbosa, Eduardo Fagiani Fraga, Tiago Manoel de Oliveira Santos"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_255.pdf",
        "name": "Avanços em Tintas para Isolamento Térmico",
        "authors": "Rosileia Mantovani, Davi Hunter"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_256.pdf",
        "name": "Study of the Corrosion Rate in the Couple of Steels ASTM A-36 and AISI/SAE 304 in a Water-coke of Petroleum System",
        "authors": "Rubén Arturo Bajares González, Leonardo Di Mella"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_257.pdf",
        "name": "Superhydrophobic Surfaces on Zinc: Application of Phosphating and Electrodeposition to Enhance Corrosion Resistance",
        "authors": "Maria Isabel Collasius Malta, Walter Leandro Cordeiro da Silva Filho, Cesar Gabriel Americo Branco, Severino Leopoldino Urtiga Filho"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_258.pdf",
        "name": "Dip-Coated SiO‚ /HDTMS Superhydrophobic Films for Improved Corrosion Resistance of Zinc Sub- strates",
        "authors": "Maria Isabel Collasius Malta, Cesar Gabriel Americo Branco, Walter Leandro Cordeiro da Silva Filho, Severino Leopoldino Urtiga Filho"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_259.pdf",
        "name": "Estações fixas para comissionamento e Inspeção de sistemas de proteção catódica em tubulações offshore, por ROV e/ou AUV",
        "authors": "Emilio Lana"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_260.pdf",
        "name": "Oxygen consumption in confined environments of seawater in contact with stainless steels",
        "authors": "Zehbour Panossian, Tarcisio H. C. Pimentel, Carlos Alberto da Silva"
    },
    {
        "url": "https://intercorr.com.br/anais/2025/intercorr2025_261.pdf",
        "name": "Low-Thickness, Low-Friction, Wear-Resistant, Fluorine-Free, and Anti-Corrosive Coating",
        "authors": "Naira Machado da Silva Ruiz, Hélio Augusto Carvalho, Alexandre Souza Brito"
    }
  ],
  message: `<p class="pb-3">Site do evento: <a href="https://abraco.org.br/intercorr2025/" target="_blank">https://abraco.org.br/intercorr2025/</a></p>`,
};
